"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LoadingScreen = require("./LoadingScreen");
Object.keys(_LoadingScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoadingScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoadingScreen[key];
    }
  });
});